




















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum SearchPredefinedStyle {
  Standard = 'search--standard',
  Responsive = 'search--responsive',
}

@Component({
  components: {
    Icon,
  },
})
export default class Search extends Vue {
  @Prop() private placeholder!: string;
  @Model('input', { type: String }) private searchValue!: string;
  @Prop({ default: false }) private clean!: boolean;
  @Prop({ default: SearchPredefinedStyle.Standard })
  private searchPredefinedStyle!: SearchPredefinedStyle;

  private content: string = '';

  @Watch('clean')
  private watchClean(newVal: boolean, oldVal: boolean) {
    this.content = '';
  }

  @Watch('searchValue')
  private watchSearchValue(newVal: string, oldVal: string) {
    this.content = newVal;
  }

  private created() {
    this.content = this.searchValue;
  }

  private get isEmpty() {
    return this.content === '';
  }

  get iconToShow() {
    let result = IconEnum.Close;
    if (this.isEmpty) {
      result = IconEnum.Search;
    }
    return result;
  }

  private handleInput() {
    this.$emit('input', this.content);
  }

  private iconClick() {
    if (!this.isEmpty) {
      this.content = '';
      this.$emit('input', this.content);
    }
  }
}
